import React from "react"
import Heading from "../../common/Heading"
import "./hero.css"
import { useLanguage } from "../../../context/LanguageContext"

const Hero = () => {
  const { content } = useLanguage()
  const { hero } = content.home

  return (
    <>
      <section className='hero'>
        <div className='container'>
          <Heading title={hero.title} subtitle={hero.subtitle} />

          <form className='flex' onSubmit={(event) => event.preventDefault()}>
            <div className='box'>
              <span>{hero.cityLabel}</span>
              <input type='text' placeholder={hero.cityPlaceholder} />
            </div>
            <div className='box'>
              <span>{hero.propertyTypeLabel}</span>
              <input type='text' placeholder={hero.propertyTypePlaceholder} />
            </div>
            <div className='box'>
              <span>{hero.priceRangeLabel}</span>
              <input type='text' placeholder={hero.priceRangePlaceholder} />
            </div>
            <div className='box'>
              <h4>{hero.advanceFilter}</h4>
            </div>
            <button type='button' className='btn1' aria-label={hero.searchButton}>
              <i className='fa fa-search'></i>
            </button>
          </form>
        </div>
      </section>
    </>
  )
}

export default Hero
